import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IThunkApi } from 'shared/types/redux';
import type { TBusinessEntityUpdateRequest } from 'shared/repositories/dailyrent/v1/business-entity/update';
import {
  TUpdateBusinessEntityError,
  updateBusinessEntityData,
} from 'shared/services/onlineBookingProfile/updateBusinessEntityData';

export const updateBusinessEntity = createAsyncThunk<
  void,
  TBusinessEntityUpdateRequest,
  IThunkApi & { rejectValue: TUpdateBusinessEntityError }
>('hostProfile/updateBusinessEntity', async (params, thunkApi) => {
  const { extra: context } = thunkApi;

  const result = await updateBusinessEntityData({
    httpApi: context.httpApi,
    logger: context.logger,
    parameters: params,
  });

  if (!result.ok) {
    return thunkApi.rejectWithValue(result.error);
  }

  return undefined;
});
